// @flow
import React from "react";
import { NumberField } from "@quantum/ui";
import { Translate } from "@quantum/i18n";
import { connect } from "react-redux";
import {
  type ActionCreator,
  editarLimite,
  getLimiteSelecionado,
  getSeparadorDecimal,
} from "../../../../state";
import { VALOR_DEFAULT_LIMITE } from "../../../../model";

type Prop = {
  limite: number,
  separadorDecimal: string,
  editarLimite: ActionCreator,
};

function SelecaoLimte({ limite, editarLimite, separadorDecimal }: Prop) {
  function handleLimiteEditado(limite) {
    editarLimite(limite);
  }

  function onBlur() {
    if (limite !== 0 && !limite) {
      editarLimite(VALOR_DEFAULT_LIMITE);
    }
  }

  return (
    <div>
      <label className="ConfiguracaoMedida__label">
        <Translate>Comum.LimiteAA</Translate>
      </label>
      <NumberField
        allowNegative={false}
        decimalScale={1}
        max={100.0}
        min={-100.0}
        onChangeValue={handleLimiteEditado}
        value={limite}
        thousandSeparator={""}
        suffix={"%"}
        decimalSeparator={separadorDecimal}
        onBlur={onBlur}
      />
    </div>
  );
}

export default connect(
  state => ({
    limite: getLimiteSelecionado(state),
    separadorDecimal: getSeparadorDecimal(state),
  }),
  { editarLimite }
)(SelecaoLimte);
